import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/parents-evening/book')({
    component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_layout/parents-evening/book"!</div>
}
